import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';

export default function SuccessDialog({ open, onClose }) {
  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth="sm"
      aria-labelledby="success-dialog"
      open={open}
    >
      <DialogContent dividers>
        <Box sx={{ mb: 2 }} display="flex" justifyContent="center">
          <DoneIcon color="success" sx={{ fontSize: 60 }} />
        </Box>
        <Typography>
          We will send an email to you when all orders have been processed.
        </Typography>
        <Typography>
          This action can take a few minutes.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}